import { Collapse, Divider, Select, Tag } from 'antd';
import Search from 'antd/es/input/Search';
import styled from 'styled-components';

export const RowLabel = styled.span`
  font-size: 15px;
  display: block;
  width: 50%;
  min-width: 500px;
`;

export const StyledDivider = styled(Divider)`
  margin: 10px 0;

  :last-child {
    display: none;
  }
`;

export const StyledSearch = styled(Search)`
  width: 300px;
  margin-left: 10px;
`;

export const StyledEmailWrapper = styled.div`
  display: flex;

  .ant-form-item {
    margin-right: 10px;
    width: 60% !important;
    min-width: 400px;
  }
`;

export const StyledCollapse = styled(Collapse)`
  margin: 10px 0 30px;

  .ant-collapse-extra {
    .ant-space-item {
      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }

  .ant-collapse-header-text {
    font-weight: 400;
    color: black;
  }
`;

export const MetricsActionWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

export const StyledSelect = styled(Select)`
  input {
    ${(props) => (props.showSearch ? { display: 'none' } : '')}
  }
`;

export const StyledInfo = styled.span`
  line-height: 2.5;
`;

export const RadioCheckboxGroupWrapper = styled.div`
  .ant-checkbox-group {
    column-gap: 0;
  }

  .ant-checkbox-wrapper {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    position: relative;
    margin: 0;
    line-height: 30px;
    padding-inline: 15px;
    color: rgb(0 0 0 / 88%);
    background: #fff;
    cursor: pointer;
    transition:
      color 0.2s,
      background 0.2s,
      border-color 0.2s,
      box-shadow 0.2s;
    border-block-start-width: 1.02px;
    border-inline-start-width: 0;
    border-inline-end-width: 1px;

    :last-child {
      border-start-end-radius: 6px;
      border-end-end-radius: 6px;
    }

    :first-child {
      border-inline-start: 1px solid #d9d9d9;
      border-start-start-radius: 6px;
      border-end-start-radius: 6px;
    }

    span:not(.ant-checkbox) {
      padding: 0;
    }
  }

  .ant-checkbox-wrapper-checked {
    z-index: 1;
    color: #0046ff !important;
    border: 1px solid #0046ff !important;

    span:not(.ant-checkbox) {
      color: #0046ff;
    }
  }

  .ant-checkbox-checked::after {
    display: none;
  }

  .ant-checkbox .ant-checkbox-inner {
    display: none;

    input[type='checkbox'] {
      width: 0;
      height: 0;
      opacity: 0;
      pointer-events: none;
    }
  }
`;

export const BetaTag = styled(Tag)`
  font-size: 12px;
  line-height: 14px;
  padding-inline: 6px;
  margin-left: 4px;
`;

export const SubscriptionCategoryName = styled.span`
  font-size: 16px;
  font-weight: bold;
`;
